import en from './data/en-US.json';

export default { 'en-US': en };
